module.exports = __webpack_public_path__ + "img/camper_interiour_5.34ed6ca5.jpg";